var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportCaseAnalysisIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75033 14.7913C0.948242 14.7913 0.291992 14.1351 0.291992 13.333V6.04134C0.291992 5.23926 0.948242 4.58301 1.75033 4.58301C2.55241 4.58301 3.20866 5.23926 3.20866 6.04134V13.333C3.20866 14.1351 2.55241 14.7913 1.75033 14.7913ZM7.58366 14.7913C6.78158 14.7913 6.12533 14.1351 6.12533 13.333V1.66634C6.12533 0.864258 6.78158 0.208008 7.58366 0.208008C8.38574 0.208008 9.04199 0.864258 9.04199 1.66634V13.333C9.04199 14.1351 8.38574 14.7913 7.58366 14.7913ZM13.417 14.7913C12.6149 14.7913 11.9587 14.1351 11.9587 13.333V10.4163C11.9587 9.61426 12.6149 8.95801 13.417 8.95801C14.2191 8.95801 14.8753 9.61426 14.8753 10.4163V13.333C14.8753 14.1351 14.2191 14.7913 13.417 14.7913Z",
    fill: "#423ED8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportCaseAnalysisIcon);
export default __webpack_public_path__ + "static/media/report-case-analysis-icon.03004295bfd56c497d71e537af20bce4.svg";
export { ForwardRef as ReactComponent };